import { Box, Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import KpiCard from "../../../components/tile/KpiCard";
import CircleView from "../../../elements/CircleView";
import InfoTile from "../../../elements/InfoTile";
import TrendView from "../../../elements/TrendView";
import { capitalizeWords } from "../../../utils/helpers";
import { useStyles } from "./styles";

const getStatusLabels = (status = "", positive = true) => {
  const labels = {
    positive: positive ? "Increased" : "Decreased",
    negative: positive ? "Decreased" : "Increased",
  };
  return labels[status.toLowerCase()];
};

const KpiDetails = ({ data }) => {
  const classes = useStyles();
  const [serviceIcon, setIcon] = useState(null);

  useEffect(() => {
    fetchIcon(data?.mostProvision);
  }, [data?.mostProvision]);

  const fetchIcon = async (service = "") => {
    service = service.toLowerCase();
    try {
      const importedIcon = await import(
        `../../../assets/aws-icons/${service}.svg`
      );
      setIcon(importedIcon.default);
    } catch (error) {
      console.error(
        `Icon for service ${service} not found, using default icon.`
      );
      setIcon(null);
    }
  };

  const renderCostDetails = () => {
    const change = data?.costPercentageChangeFromPrevMonth;
    const title =
      change && change !== 0
        ? `${Math.abs(change)}% 
    ${getStatusLabels(data?.costChangeStatus, false)}`
        : "No Change";
    return (
      <KpiCard>
        <Box display="flex" justifyContent="space-between">
          <Box>
            <InfoTile
              title="Cost"
              value={data?.totalCost != null ? `$${data?.totalCost}` : "-"}
            />
            <Box mt={3}>
              <TrendView
                variant={
                  data?.costChangeStatus === "negative" ? "error" : "success"
                }
                title={title}
                trendType={
                  data?.costChangeStatus === "negative" ? "up" : "down"
                }
                noChange={change === 0}
              />
            </Box>
          </Box>
          <Divider sx={{ borderWidth: "1px", mx: 1 }} />
          <InfoTile
            title="Forecasted"
            value={data?.forecastCost != null ? `$${data?.forecastCost}` : "-"}
          />
        </Box>
      </KpiCard>
    );
  };

  const renderScore = () => {
    const change = data?.securityPercentageChangeFromPrevMonth;
    const title =
      change && change !== 0
        ? `${Math.abs(change)}% 
      ${getStatusLabels(data?.securityChangeStatus)}`
        : "No Change";
    return (
      <KpiCard>
        <Box>
          <InfoTile
            title="Security Score"
            value={
              data?.securityScore != null ? `${data?.securityScore}%` : "-"
            }
          />
          <Box mt={3}>
            <TrendView
              variant={
                data?.securityChangeStatus === "negative" ? "error" : "success"
              }
              title={title}
              trendType={
                data?.securityChangeStatus === "negative" ? "down" : "up"
              }
              noChange={change === 0}
            />
          </Box>
        </Box>
      </KpiCard>
    );
  };
  return (
    <Grid container spacing={3}>
      <Grid item xl={3}>
        {renderCostDetails()}
      </Grid>
      <Grid item xl={2}>
        {renderScore()}
      </Grid>
      <Grid item xl={2}>
        <KpiCard>
          <Box className={classes.centerAlign}>
            <Typography gutterBottom={true}>Total Provisions</Typography>
            <CircleView value={data?.totalProvision || 0} />
          </Box>
        </KpiCard>
      </Grid>
      <Grid item xl={2}>
        <KpiCard>
          <Box className={classes.centerAlign}>
            <Typography gutterBottom={true}>Total Assessments</Typography>
            <CircleView
              variant="secondary"
              value={data?.totalAssessments || 0}
            />
          </Box>
        </KpiCard>
      </Grid>
      <Grid item xl={3}>
        <KpiCard>
          <Box className={classes.centerAlign}>
            <Typography gutterBottom={true}>
              Most Provisioned Service
            </Typography>
            {serviceIcon && <img src={serviceIcon} alt={data?.mostProvision} />}
            <Typography variant="h6">
              {capitalizeWords(data?.mostProvision) || "-"}
            </Typography>
          </Box>
        </KpiCard>
      </Grid>
    </Grid>
  );
};

export default KpiDetails;
